ClubCourtsController.$inject = [
    '$scope',
    'CONST',
    'Club',
    'Court',
    'Time',
    '_',
    '$aside',
    'alerts',
    'User',
    'API',
];

/* @ngInject */
function ClubCourtsController(
    $scope,
    CONST,
    Club,
    Court,
    Time,
    _,
    $aside,
    alerts,
    User,
    API,
) {
    var vm = this;
    vm.title = 'ClubCourtsController';

    vm.loading = {
        all: true,
        new: false,
        sorting: false,
    };
    vm.courts = [];
    vm.addHidden = true;

    // Constants
    vm.sports = _.values(CONST.sports);
    vm.attributes = _.clone(CONST.attributes.court);
    vm.floors = _.clone(CONST.attributes.court_floor);

    // Sort
    vm.sort_changed = false;

    // Payments
    vm.hasOnlinePayments = CONST.online_payment;

    // Methods

    vm.toggle_state = function (court, state = null) {
        alerts
            .code(null, null, User)
            .then(toggle_state.bind(this, court, state));
    };

    vm.store = function () {
        alerts.code(null, null, User).then(store);
    };

    vm.edit = function (court) {
        alerts.code(null, null, User).then(edit.bind(this, court));
    };

    vm.add_transformable = function (court, childrenId) {
        court.transformAdd = false;
        alerts.code().then(transformable_add.bind(this, court, childrenId));
    };

    vm.remove_transformable = function (court, childrenId) {
        alerts
            .confirm(
                '¿Estás seguro que querés desvincular la sub-cancha?',
                'Todas los turntoggle_stateos bloqueados por la vinculación de las canchas se liberarán. (Esta acción no se puede deshacer)',
            )
            .then(alerts.code)
            .then(transformable_remove.bind(this, court, childrenId));
    };

    vm.sort = function () {
        alerts.code(null, null, User).then(sort);
    };

    /*
    vm.delete = function (court) {
        alerts.code(null, null, User).then();
    };
    */

    vm.edit_price = function (court) {
        $aside
            .open({
                template: require('../../../views/club/courts.prices.aside.html'),
                placement: 'right',
                size: 'lg',
                backdrop: 'static',
                controller: 'ClubCourtsPricesController',
                controllerAs: 'vm',
                bindToController: true,
                resolve: {
                    court: court,
                },
            })
            .result.then(angular.noop)
            .catch(angular.noop);
    };

    // vm.edit_reservation_rule = function (court) {
    //     $aside.open({
    //         template: require('../../../views/club/courts.reservation-rules.html'),
    //         placement: 'right',
    //         size: 'xl',

    //         controller: function () {
    //             var vm = this;

    //             vm.court = court;
    //         },
    //         controllerAs: 'vm',
    //         bindToController: true,
    //     });
    // };

    vm.edit_payment = function (court) {
        if (!vm.hasOnlinePayments) {
            return;
        }

        $aside
            .open({
                template: require('../../../views/club/courts.payment.aside.html'),
                placement: 'right',
                size: 'lg',
                backdrop: 'static',
                controller: 'ClubCourtsPaymentController',
                controllerAs: 'vm',
                bindToController: true,
                resolve: {
                    court: court,
                },
            })
            .result.then(angular.noop)
            .catch(angular.noop);
    };

    vm.edit_policy = function (court) {
        if (!vm.hasOnlinePayments) {
            return;
        }
        $aside
            .open({
                template: require('../../../views/club/courts.policy.aside.html'),
                placement: 'right',
                size: 'md',
                backdrop: 'static',
                controller: 'ClubCourtsPolicyController',
                controllerAs: 'vm',
                bindToController: true,
                resolve: {
                    court: court,
                },
            })
            .result.then(angular.noop)
            .catch(angular.noop);
    };

    vm.disable = function (court) {
        alerts
            .confirm(
                'Eliminar',
                '¿Estás seguro que deseas desactivar esta cancha?',
            )
            .then(alerts.code)
            .then(disable.bind(this, court));
    };

    var attr_names = [
        'name',
        'round_start',
        'sports',
        'attributes',
        'parent_id',
        'disclaimer',
    ];
    var attr_defaults = {
        name: '',
        round_start: null,
        sports: [],
        attributes: {
            floor: '',
            roofed: false,
            light: false,
        },
        isTransformable: false,
        parent_id: null,
        disclaimer: '',
        advance_type: 'flat',
    };

    vm.listParents = function (court) {
        return Court.list(function (c) {
            return c.id !== court.id && court.parent_id !== c.id;
        });
    };

    activate();

    ////////////////

    function activate() {
        vm.create = court_defaults();
        // Fetch courts
        Club.API.getList('courts', {
            full: true,
        }).then(function (courts) {
            // Courts parse:
            vm.loading.all = false;
            vm.courts = parse_courts(courts);

            if (vm.courts[0].sportclub_beelup_status != false) {
                beelupGetCourts();
            }
            update_children();
        });
    }

    function parse_court(data) {
        var court = Court.create(data, true);
        court._collapsed = true;
        court.sports = _(court.sports).mapValues('id').values().value();
        if (!court.attributes) {
            court.attributes = _.clone(attr_defaults.attributes);
        }
        if (court.attributes.floor === 'blindex') {
            // Blindex no existe mas, es para las canchas viejas que aun tienen configurado ese piso de la cancha
            court.attributes.floor = 'blindex-synthetic';
        }
        court.isTransformationLocked = court.parent_id !== null;

        return court;
    }

    // Initialize courts
    function parse_courts(courts) {
        return _.extend(courts, _.map(courts, parse_court));
    }

    /**
     * @method store
     * @param  {string} code
     */
    function store(code) {
        var data = format_create(vm);
        data.code = code;

        vm.loading.new = true;
        vm.courts
            .post(data)
            .then(function (court_data) {
                var court = parse_court(court_data);
                court._collapsed = false;

                vm.courts.push(court);
                vm.create = court_defaults();
                update_children();
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading.new = false;
            });
    }

    /**
     * @method toggle_state
     * @param  {Court} court
     * @param  {String} code
     * @return {Promise}
     */
    function toggle_state(court, state = null, code) {
        var data = {
            code: code,
            state: state,
        };

        vm.loading[court.id] = true;
        return court.api
            .customPUT(data, '')
            .then(() => {
                court.state = court.state === 2 ? 1 : 2;
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading[court.id] = false;
                if (state === 0) {
                    alerts.success('Exito', 'La cancha fue eliminada');
                    vm.courts = parse_courts(
                        vm.courts.filter((c) => c.id !== court.id),
                    );
                }
            });
    }

    /**
     * @method edit
     * @param  {Court} court
     * @param  {String} code
     * @return {Promise}
     */
    function edit(court, code) {
        var data = format_edit(court);
        data.code = code;

        vm.loading[court.id] = true;

        if (
            court.sportclub_beelup_status != false &&
            vm.beelupCourt !== undefined &&
            court.beelup_court_status == null
        ) {
            vm.beelupConnect(court);
        }

        return court.api
            .customPUT(data, '')
            .then(function () {
                update_children();
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading[court.id] = false;
            });
    }

    /**
     * Link sub-court as child.
     *
     * @method transformable_add
     * @param  {Court} court
     * @param  {Numeric} childrenId
     * @param  {String} code
     * @return {Promise}
     */
    function transformable_add(court, childrenId, code) {
        vm.loading[court.id] = true;

        return court.api
            .customPOST(
                {
                    code: code,
                    children_id: childrenId,
                },
                'transformable',
            )
            .then(function () {
                var target = Court.get(childrenId);
                target.parent_id = court.id;
                target.parent = court;

                // court.parent_id = null;
                // court.isTransformable = false;
                court.isTransformationLocked = false;

                court.transformAdd = false;

                update_children();
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading[court.id] = false;
            });
    }

    /**
     * Unlink parent from court. (Removes every booking-blocker made)
     *
     * @method transformable_remove
     * @param  {Court} court
     * @param  {Numeric} childrenId
     * @param  {String} code
     * @return {Promise}
     */
    function transformable_remove(court, childrenId, code) {
        vm.loading[court.id] = true;

        return court.api
            .customDELETE('transformable', {
                code: code,
                children_id: childrenId,
            })
            .then(function () {
                // court.parent_id = null;
                Court.get(childrenId).parent_id = null;

                update_children();
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading[court.id] = false;
            });
    }

    /**
     * Sync courts order
     *
     * @method sort
     */
    function sort(code) {
        var courts = _.map(vm.courts, function (court, index) {
            court.order = index;
            return court.id;
        });

        vm.loading.sorting = true;

        vm.courts
            .customPUT(
                {
                    code: code,
                    courts: courts,
                },
                'sort',
            )
            .then(function () {
                vm.sort_changed = false;
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading.sorting = false;
            });
    }

    /**
     * @method disable
     * @param  {Court} court
     * @param  {String} code
     * @return {Promise}
     */
    function disable(court, code) {
        // TODO toggle disable
        return;
        court.state = 0;
        var data = {
            code: code,
            state: court.state,
        };

        vm.loading[court.id] = true;
        return court.api
            .customPUT(data, '')
            .then(function () {
                court.disabled = true;
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading[court.id] = false;
            });
    }

    function update_children() {
        _.each(vm.courts, function (court) {
            court.parent = court.parent_id ? Court.get(court.parent_id) : null;
            court.children = court.getChildren();
        });
    }

    // Formatting
    function format_edit(court) {
        var data = _.pick(court, attr_names);
        return data;
    }

    function format_create(vm) {
        return _.pick(vm.create, attr_names);
    }

    function court_defaults() {
        return _.cloneDeep(attr_defaults);
    }

    function beelupGetCourts() {
        vm.loading.all = true;
        Club.API.customGET('beelup/get/beelup-courts')
            .then((data) => {
                vm.beelupCourts = data.data;
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading.all = false;
            });
        return;
    }

    vm.beelupConnect = function (court) {
        Club.API.customPOST(
            {
                beelup_device_hostname: vm.beelupCourt.model.device_hostname,
                requester_court: court.id,
            },
            'beelup/connect/court',
        )
            .then(function (res) {
                court.beelup_court_status = res;
                beelupGetCourts();
            })
            .catch(alerts.errorHandler);
    };

    vm.beelupDisconnect = function (court) {
        alerts
            .confirm(
                'Conexión Beelup',
                '¿Realmente desea cancelar la conexión de su cancha de Beelup?',
            )
            .then(beelupDisconnectRequest.bind(this, court));
    };

    function beelupDisconnectRequest(court) {
        // console.log(court);
        vm.loading[court.id] = true;
        Club.API.customPOST(
            {
                court_id: court.id,
            },
            'beelup/disconnect/court',
        )
            .then(function (res) {
                if ((res.original.status = 200)) {
                    court.beelup_court_status = null;
                    beelupGetCourts();
                }
                vm.loading[court.id] = false;
            })
            .catch(alerts.errorHandler);
    }

    // vm.drag = function () {
    //     const canchas = document.querySelectorAll('.draggable');
    //     console.log({ canchas });
    //     console.log('Holaa');
    //     // canchas.forEach((cancha) => {
    //     //     cancha.addEventListener('dragstart', () => {
    //     //         console.log(cancha);
    //     //     });
    //     // });
    // };

    vm.courtUp = function (court) {
        const index = vm.courts.findIndex((c) => c.name === court.name);
        if (!index) return;
        vm.sort_changed = true;

        const selectd_court = document.querySelector(`#court-${court.id}`);
        selectd_court.classList.toggle('court-card-moveUp');

        vm.courts.splice(index, 1);
        vm.courts.splice(index - 1, 0, court);

        setTimeout(() => {
            selectd_court.classList.toggle('court-card-moveUp');
        }, 100);
    };

    vm.courtDown = function (court) {
        const index = vm.courts.findIndex((c) => c.name === court.name);
        if (index === vm.courts.length - 1) return;

        const selectd_court = document.querySelector(`#court-${court.id}`);
        selectd_court.classList.toggle('court-card-moveDown');

        vm.sort_changed = true;
        vm.courts.splice(index, 1);
        vm.courts.splice(index + 1, 0, court);

        setTimeout(() => {
            selectd_court.classList.toggle('court-card-moveDown');
        }, 100);
    };
}

export default ClubCourtsController;
